export default __webpack_public_path__ + "static/media/clinicImage.a0f4f627.jpg";